import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

// ** Fetch daily_works
export const getScheduleDownloadList = createAsyncThunk('appScheduleDownloadList/getScheduleDownloadList', async (params) => {
  const response = await axios.get('/api/schedule_download', { params })
  return response.data
})

export const getWorkReportDownloadData = createAsyncThunk('appScheduleDownloadList/getWorkReportDownloadData', async  (params) => {
  const response = await axios.get('/api/schedule_download/download_report', {params})
  return response.data
})

export const getUserList = createAsyncThunk('appScheduleDownloadList/getUserList', async  (params) => {
  const response = await axios.get('/api/schedule_download/getSingleUser', {params})
  return response.data
})

export const appScheduleDownloadListSlice = createSlice({
  name: 'ScheduleDownloadList',
  initialState: {
    singleData: {},   // Data for a single user
    data: [],         // Data for a list of daily_works
    total: 0,
    params: {},
    allData: [],      // (Optional) Store all user data if needed
    status: 'idle',
    message:null,
    errors: null
  },
  reducers: {
    resetSingleUser: (state) => {
      state.singleData = {}; // Reset single user data
    },
    resetStateIdele: (state) => {
      state.status = 'idle'; // Reset single user data
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple daily_works
    builder
      .addCase(getScheduleDownloadList.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getScheduleDownloadList.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.allData = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getScheduleDownloadList.rejected, (state, action) => {
        state.status = 'failed'
        // state.message = action.payload.message
        // state.errors = action.payload.errors
      })

    // ** Add User
    builder
      .addCase(getWorkReportDownloadData.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getWorkReportDownloadData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getWorkReportDownloadData.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = action.payload.errors
      })

      builder
      .addCase(getUserList.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.singleData = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.status = 'failed'
        // state.message = action.payload.message
        // state.errors = action.payload.errors
      })

  }
})

export const { resetSingleUser, resetStateIdele } = appScheduleDownloadListSlice.actions;

export default appScheduleDownloadListSlice.reducer
